module.exports = __webpack_public_path__ + "img/01_img.0b75bbdb.png";